module.exports = "/images/ny-life1-6.jpg";